import request from '../utils/http'
// 版本列表
export function index (query) {
  return request({
    url: '/edition/list',
    method: 'GET',
    params: query
  })
}
// 新增版本
export function save (query) {
  return request({
    url: '/edition/save',
    method: 'POST',
    data: query
  })
}
// 编辑版本
export function edit (query) {
  return request({
    url: '/edition/edit',
    method: 'GET',
    params: query
  })
}
// 更新版本
export function update (query) {
  return request({
    url: '/edition/update',
    method: 'POST',
    data: query
  })
}
// 删除版本
export function del (query) {
  return request({
    url: '/edition/delete',
    method: 'DELETE',
    data: query
  })
}
// 版本开关
export function show (query) {
  return request({
    url: '/edition/show',
    method: 'POST',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/edition.js